export default {
    _prefix: "ScoreOverview",
    title: {
        scaled: "Scaled Scores",
        unscaled: "Scores",
        totalScoreLabel: "Score: ",
        criticalScoreLabel: "Critical Score: ",
        npsScoreLabel: "NPS: ",
        npsScoreEmptyLabel: "N/A",
    },
    criticalPercentage: "{{percentage}} ({{criticalPercentage}})",
    expandScores: "Click to expand score details",
    collapseScores: "Click to collapse score details",
    statusDetailsExpanded: "Score details expanded",
    statusDetailsCollapsed: "Score details collapsed",
    ariaLabels: {
        totalScore: (data: { percentage: string }) => "Score: {{percentage}}",
        criticalScore: (data: { percentage: string }) =>
            "Critical Score: {{percentage}}",
        npsScore: (data: { value: string }) => "NPS: {{value}}",
    },
};
